import { useCallback, useEffect, useState } from 'react';
import { stockService } from '../../../services/stockService';

const MIN_LOADING_STATE_MS = 600;

const wait = (durationMs) =>
  new Promise((resolve) => {
    setTimeout(resolve, durationMs);
  });

export const useAdminStocks = () => {
  const [stocks, setStocks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadStocks = useCallback(async (signal) => {
    try {
      setLoading(true);
      setError(null);

      const [data] = await Promise.all([
        stockService.list({ signal }),
        wait(MIN_LOADING_STATE_MS),
      ]);

      if (!signal.aborted) {
        setStocks(data);
      }
    } catch (err) {
      if (err?.name === 'AbortError') {
        return;
      }

      setError(err?.message || 'Failed to fetch stocks');
    } finally {
      if (!signal.aborted) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    loadStocks(controller.signal);

    return () => {
      controller.abort();
    };
  }, [loadStocks]);

  return {
    stocks,
    loading,
    error,
  };
};
